<template>
    <div>
        <!-- TODO проверить центрирование компонента -->
        <div
            class="login-form-session"
        >
            <p class="subtitle">Введите логин и пароль для продолжения работы</p>

            <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
            </div>

            <a-form
                ref="formRef"
                :model="formState"
                :rules="formValidationRules"
            >
                <a-form-item name="login">
                    <a-input
                        v-model:value="formState.login"
                        placeholder="Логин"
                    />
                </a-form-item>
                <a-form-item name="password">
                    <a-input-password
                        v-model:value="formState.password"
                        placeholder="Пароль"
                    />
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button
                        type="primary"
                        data-test-id="login-btn"
                        :disabled="isValid"
                        @click="onSubmit"
                    >
                        Продолжить
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { showErrorNotification, RouterConfig } from '@/utils';

export default defineComponent({
    name: 'SessionSignIn',
    data() {
        return {
            formState: {
                login: '',
                password: '',
            },
            formValidationRules: {
                login: [{ required: true, message: 'Обязательное поле' }],
                password: [{ required: true, message: 'Обязательное поле' }],
            },
            errorMessage: '',
        };
    },
    computed: {
        isValid() {
            return !(this.formState.login && this.formState.password);
        },
    },
    methods: {
        onSubmit() {
            this.$refs.formRef.validate().then(({ login, password }) => {
                this.login(login, password);
            }, () => {});
        },

        async login(username, password) {
            try {
                const { deviceId, staffId } = localStorage;
                const response = await this.$http.post('/v2/auth/login', {
                    username,
                    password,
                    deviceId,
                    userId: staffId,
                    isSession: true,
                });

                const { user = {} } = response.data;

                if (Object.keys(user).length) {
                    const {
                        name,
                        previewFileId,
                        clinics,
                        id,
                        chatUserId,
                        chatUserToken,
                    } = user || {};

                    localStorage.username = name;
                    localStorage.previewFileId = previewFileId;
                    localStorage.clinics = clinics;
                    localStorage.staffId = id;
                    localStorage.chatUserId = chatUserId;
                    localStorage.chatUserToken = chatUserToken;
                }

                localStorage[RouterConfig.loginSignIn.name] = JSON.stringify(response.data);

                this.errorMessage = '';

                this.$emit('success');
            } catch (error) {
                if (error.response?.data?.msg) {
                    this.errorMessage = error.response.data.msg;

                    if (error.response.data.msg.includes('Доступ' || 'заблокирована')) {
                        this.$emit('no-access');
                    }
                } else {
                    showErrorNotification('Ошибка. Попробуйте позже', 5000);
                }
            }
        },

        onForgotPassword() {
            this.$router.push({ name: RouterConfig.forgot.name });
        },

        onOldAuth() {
            this.$router.push({ name: RouterConfig.loginOld });
        },
        onForgotPin() {
            this.$emit('forgot-pin');
        },
    },
});
</script>

<style lang="scss" scoped>
.app-title {
    display: block;
    color: #00706c;
    font-weight: 600;
    font-size: 14px;
    font-family: Arial, sans-serif !important;
    margin-bottom: 20px;
    margin-top: 0px;
    text-align: center;
}

.login-form-session {
    display: flex;
    flex-direction: column;
    align-items: center;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    .ant-form-item {
        margin-block: 8px;

        &:last-child {
            margin-top: 20px;
            margin-bottom: 0;
        }
    }

    .ant-form-explain {
        margin-bottom: -17px;
        text-align: left;
        font-size: 13px;
    }

    img {
        display: block;
        margin: 0 auto 4px;
        max-width: 100px;
    }

    .additional-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .ant-btn {
            text-align: center;
            padding: 0;
            width: fit-content;
            height: auto;
            text-decoration: none;
            color: #83b274;
            font-size: 14px;
            margin: 0 auto;
            border: none;
            background-color: transparent;
            box-shadow: none;

            &:disabled,
            &[disabled] {
                pointer-events: none;
                opacity: 0.5;
            }

            &:hover {
                color: #74b85d;
            }
        }
    }

    & .ant-btn.ant-btn-primary {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-bottom: 18px;

        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }

    & .ant-input,
    & .ant-input-password {
        height: 36px;
        border-radius: 4px;

        &:hover {
            border-color: #83b274;
        }

        &:focus,
        &:has(input:focus) {
            border-color: #83b274;
            box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
        }
    }

    & .ant-form-item-has-error .ant-input,
    & .ant-form-item-has-error .ant-input-password {
        border-color: #ff4d4f;
        box-shadow: 0 0 0 2px rgba(255, 77, 77, 0.2);
    }

    :deep(.ant-form-item-explain.ant-form-item-explain-error) {
        text-align: left;
    }

    .error-message {
        color: #ff4d4f;
        font-size: 14px;
        margin-bottom: 8px;
        text-align: left;
        max-width: 100%;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }
}

.text-center {
    text-align: center;
}
</style>
